/**
 * @fileoverview GET handler for the "/engagement/:app_group_id/test_send/free_trial_allowed_domains" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementAppGroupIdTestSendFreeTrialAllowedDomains } from "./constants";
import type { EngagementAppGroupIdTestSendFreeTrialAllowedDomainsResult } from "./types";

export const getEngagementAppGroupIdTestSendFreeTrialAllowedDomains = reactQueryFetcherAdapter(
  engagementAppGroupIdTestSendFreeTrialAllowedDomains,
  (signal: AbortSignal, appGroupId: string): Promise<EngagementAppGroupIdTestSendFreeTrialAllowedDomainsResult> => {
    return fetch(`/engagement/${appGroupId}/test_send/free_trial_allowed_domains`, "GET", {}, { signal });
  }
);
